import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

const defaultAction = {
  label: 'OK',
  variant: 'light',
};

export const OKAction = (onClick) => ({
  label: 'OK',
  variant: 'primary',
  onClick,
});

export const Action = (
  label = defaultAction.label,
  onClick,
  variant = defaultAction.variant,
  buttonComponent,
) => ({
  label,
  variant,
  onClick,
  buttonComponent,
});

export default class BootstrapDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      title: '',
      body: '',
      actions: [],
    };
  }

  show = ({ title, body, actions }) => {
    this.setState({
      show: true,
      title,
      body,
      actions,
    });
  };

  hide = () => this.setState({ show: false });

  onActionButtonClicked = (onClick) => {
    if (typeof onClick === 'function') {
      onClick();
    }
    this.hide();
  };

  render() {
    const { show, title, body, actions } = this.state;

    return (
      <Modal
        onHide={this.hide}
        show={show}
      >
        {title && (
          <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
        )}
        {body && <Modal.Body>{body}</Modal.Body>}
        {(actions || []).length > 0 && (
          <Modal.Footer>
            {(actions || []).map(
              ({ label, variant, onClick, buttonComponent }, ndx) =>
                buttonComponent ? (
                  <div
                    key={ndx}
                    onClick={() => this.onActionButtonClicked(onClick)}
                  >
                    {buttonComponent}
                  </div>
                ) : (
                  <Button
                    key={ndx}
                    onClick={() => this.onActionButtonClicked(onClick)}
                    variant={variant}
                  >
                    {label}
                  </Button>
                ),
            )}
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}
